import { render, staticRenderFns } from "./TranslatorButton.vue?vue&type=template&id=ec0b5336&scoped=true&"
import script from "./TranslatorButton.vue?vue&type=script&lang=js&"
export * from "./TranslatorButton.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorButton.vue?vue&type=style&index=0&id=ec0b5336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0b5336",
  null
  
)

export default component.exports